var Backbone = require('backbone'),
    Hit = require('./hit');

// Want Collection?  may be easier having JSON object of id x hit
// Here, the id is the hit id of the model ( really in order of appearance )

module.exports = Backbone.Collection.extend({

    model: Hit,

    getResultsForPage: function( pageNumber ) {

        return this.where({ pageNumber: pageNumber });

    },

    // Note: pageId must be integers
    getResultsForPageId: function( pageId ) {

        return this.filter( function(hit) {
            return hit.get('pageId') === pageId;
        });

    },

    getAllShapesPerPage: function ( pageId ) {

        var hitsOfPage = this.where({
            pageId: pageId
        });

        return hitsOfPage.map( function(hit) {
           return hit.get('shape');
        });

    },

    getAppliedHits: function() {

       return this.filter( function(hit) {
          return hit.get('isApplied');
       });

    },

    getByPageAndSearch: function( pageId, searchId ) {

        return this.filter( function(h) {
            return h.get('searchModelId') === searchId && h.get('pageId') == pageId;
        });
    },

    getHitsForSearch: function( searchId ) {

        return this.filter( function(h) {
            return h.get('searchModelId' ) === searchId;
        });

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/hit/hits.js
 ** module id = 663
 ** module chunks = 0
 **/